import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { Spinner } from "reactstrap";

import { getSupervisors } from "../../redux/actions/security/userActions";

/**
 *
 * @param supervisors
 * @param getSupervisors
 * @param isDisabled
 * @param initialSupervisor
 * @param setSupervisor
 * @returns {JSX.Element}
 * @constructor
 */
const SelectSupervisor = ({
    selectors:{ supervisors },
    getSupervisors,
    isDisabled = false,
    initialSupervisor,
    assignSupervisor
}) => {
    const [loading, setLoading] = useState(false)
    const [selectedSupervisor, setSelectedSupervisor] = useState(null)

    const isMounted = useRef( true)

    // mounted or unmounted component
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    // load supervisors
    useEffect(() => {
        if(supervisors !== null )
            refreshSupervisors()

    },[] )

    // load default supervisor
    useEffect(() => {
        if(initialSupervisor != null && supervisors.length > 0){
            const supervisor = supervisors.find( i => i.id === initialSupervisor)
            setSelectedSupervisor(supervisor)
        }
    }, [ supervisors ])

    const refreshSupervisors = async () => {
        changeLoading(true)
        await getSupervisors()
        changeLoading(false)
    }

    const changeLoading = status => {
        if(isMounted.current)
            setLoading(status)
    }

    return <>
        {
            loading ? <Spinner animation="border" /> : <Select
                value={ selectedSupervisor }
                options={ supervisors || [] }
                isDisabled={ isDisabled }
                onChange={ val => {
                    setSelectedSupervisor(val)
                    assignSupervisor(val?.id)
                } }
            />
        }
    </>
}

const mapStateToProps = state => ({ selectors : state.selectors })
const mapActionsToProps = ({ getSupervisors })

export default connect(mapStateToProps, mapActionsToProps)(SelectSupervisor)